import React from 'react';
import Chip from './Chip';

export const createPills = (data, dataSource, deleteCallback, options = {}) => {

    let disabled, key;
    if (typeof options === "boolean") { //for bw compatibility
        disabled = options;
        key = 'id';
    } else {
        disabled = !!options.disabled;
        key = options.key || 'id';
    }
    if (!data || data.length === 0 || !dataSource || dataSource.length === 0) return null;

    return data.map((element) => {
        const id = (element.hasOwnProperty(key) ? element[key] : element);
        let d = dataSource.find((e) => !!e && e[key] === id);
        if (d === undefined) {
            d = {name: element.name||'Unknown'};
        } else if (d.name === undefined && d.firstName !== undefined && d.lastName !== undefined) {
            d.name = `${d.firstName || ''} ${d.lastName || ''}`;
        }

        const  onDelete = (!element.loading && !!deleteCallback) ? () => deleteCallback(id) : null;

        return (
            <Chip
                key={id}
                label={d.name}
                disabled={disabled}
                onDelete={onDelete}
            />

        );
    });
};

export default {
    create: createPills
};